// src\app\constants\app-constants.ts
/**
 * Menu interface for navigation component, used to represent a nav link to a specific menu
 */
export type MenuLink = {
  url: string;
  title: string;
  icon?: string;
  svg?: {
    default: string;
    active: string;
  };
  allowedRole: 'BORROWER' | 'SUPPLIER' | 'ALL';
  hideFromNavigation?: boolean;
};

/**
 * Global app constants
 */
export class AppConstants {
  static readonly KEY_TOKEN = "token";

  static DATE_FORMAT = "MM/dd/yyyy";
  static MENU_HOME = "home";
  static MENU_REQUESTS = "requests";
  static MENU_APPLICATIONS_INVITES = "applications";
  static MENU_CREATE_ACCOUNT = "create-account";
  static MENU_CUSTOMERS = "customers";
  static MENU_FORGOT_PASSWORD_REQUEST = "forgot-password";
  static MENU_CHANGE_PASSWORD = "change-password";
  static MENU_LOGIN = "login";
  static MENU_SIGNUP = "signup";
  static MENU_SESSION_EXPIRED = "session-expired";
  static MENU_SUPPLIER_TRANSACTIONS = "supplier-transactions";
  static MENU_BORROWER_TRANSACTIONS = "borrower-transactions";
  static MENU_SETTINGS = "settings"; // New constant
  static MENU_TOS = "tos";
  static MENU_PEOPLE = "people";
  static MENU_TRANSACTION_DETAILS = "transaction-detail";

  static API_FETCH_INTERVAL = 1000 * 60; // Set API fetch interval to 1 minute

  static SESSION_TIMEOUT_ENABLED = true;

  static TITLE_APPLICATIONS_INVITES = "Applications & Invites";
  static TITLE_CUSTOMERS = "Customers";
  static TITLE_TRANSACTIONS = "Transactions";
  static TITLE_HOME = "Home";
  static TITLE_REQUESTS = "Requests";

  static MENU_LINKS: MenuLink[] = [
    {
      url: AppConstants.MENU_APPLICATIONS_INVITES,
      title: AppConstants.TITLE_APPLICATIONS_INVITES,
      icon: 'sticky_note_2',
      allowedRole: "SUPPLIER",
    },
    {
      url: AppConstants.MENU_CUSTOMERS,
      title: AppConstants.TITLE_CUSTOMERS,
      icon: 'people_alt',
      allowedRole: "SUPPLIER",
    },
    {
      url: AppConstants.MENU_SUPPLIER_TRANSACTIONS,
      title: AppConstants.TITLE_TRANSACTIONS,
      icon: 'compare_arrows',
      allowedRole: "SUPPLIER",
    },
    {
      url: AppConstants.MENU_HOME,
      title: AppConstants.TITLE_HOME,
      icon: 'home',
      allowedRole: "BORROWER",
    },
    {
      url: AppConstants.MENU_BORROWER_TRANSACTIONS, 
      title: AppConstants.TITLE_TRANSACTIONS, 
      icon: 'compare_arrows', 
      allowedRole: "BORROWER",
    },
    {
      url: AppConstants.MENU_REQUESTS,
      title: AppConstants.TITLE_REQUESTS,
      icon: 'sticky_note_2',
      allowedRole: "BORROWER",
    },
    {
      url: AppConstants.MENU_PEOPLE,
      allowedRole: 'ALL',
      title: "People",
      icon: "people",
      hideFromNavigation: false
    },
    {
      url: AppConstants.MENU_SETTINGS,
      title: "Settings",
      icon: "settings", // using a material icon name
      allowedRole: "ALL",
    },
    { url: `${AppConstants.MENU_TRANSACTION_DETAILS}/:id`,
      allowedRole: 'ALL' ,
      title: "Transaction Details",
      icon: "settings", // using a material icon name
      hideFromNavigation: true
    },
    {
      url: AppConstants.MENU_TOS,
      allowedRole: 'ALL',
      title: "Terms of Service",
      icon: "settings", // using a material icon name
      hideFromNavigation: true
    },

  ];
}
